import { Button, Input, type TableColumnsType } from 'antd';
import type { TaskStatisticsOutputDto } from '../model';

export const accountNameColumn: TableColumnsType<
  TaskStatisticsOutputDto['account_stats'][number]
>[number] = {
  title: '账户',
  render: (_, row) => row.account_name,
  filterDropdown: ({
    selectedKeys,
    setSelectedKeys,
    confirm,
    clearFilters,
  }) => (
    <div className="flex w-48 flex-col gap-2 p-2">
      <Input
        allowClear
        size="small"
        placeholder="输入用户名搜索"
        value={String(selectedKeys[0] ?? '')}
        onChange={(event) => {
          const keyword = event.target.value;
          setSelectedKeys(keyword ? [keyword] : []);
        }}
        onPressEnter={() => confirm()}
      />
      <div className="flex items-center">
        <Button
          variant="text"
          size="small"
          color="default"
          onClick={() => clearFilters?.({ confirm: true, closeDropdown: true })}
        >
          重置
        </Button>
        <div className="flex-auto"></div>
        <Button
          variant="solid"
          color="primary"
          size="small"
          onClick={() => confirm()}
        >
          搜索
        </Button>
      </div>
    </div>
  ),
  onFilter: (value, record) => {
    return record.account_name
      .toLowerCase()
      .includes(String(value).trim().toLowerCase());
  },
};
